module.exports = __webpack_public_path__ + "static/media/logo.ddbd21cc.svg";